import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveOrderNoteInput } from './SaveOrderNoteInput';
import { SaveOrderNoteOutput } from './SaveOrderNoteOutput';

export class SaveOrderNoteService extends HttpServiceBase {

  handle = (input: SaveOrderNoteInput): Promise<Result<SaveOrderNoteOutput> | null> => {
    const promise = this.http.post<Result<SaveOrderNoteOutput>, SaveOrderNoteInput>(`${this.baseUrlSislogApi}/v2/order-note`, input);
    return promise;
  }
}